"use strict";

var _slicedToArray = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Canvas = void 0;

var Utils_1 = require("../Utils");

var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    _classCallCheck(this, Canvas);

    this.container = container;
    this.size = {
      height: 0,
      width: 0
    };
    this.context = null;
    this.generatedCanvas = false;
  }

  _createClass(Canvas, [{
    key: "init",
    value: function init() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

      this.resize();
      var options = this.container.options;
      var element = this.element;

      if (element) {
        if (options.backgroundMode.enable) {
          this.originalStyle = Utils_1.Utils.deepExtend({}, element.style);
          element.style.position = "fixed";
          element.style.zIndex = options.backgroundMode.zIndex.toString(10);
          element.style.top = "0";
          element.style.left = "0";
          element.style.width = "100%";
          element.style.height = "100%";
        } else {
          element.style.position = (_b = (_a = this.originalStyle) === null || _a === void 0 ? void 0 : _a.position) !== null && _b !== void 0 ? _b : "";
          element.style.zIndex = (_d = (_c = this.originalStyle) === null || _c === void 0 ? void 0 : _c.zIndex) !== null && _d !== void 0 ? _d : "";
          element.style.top = (_f = (_e = this.originalStyle) === null || _e === void 0 ? void 0 : _e.top) !== null && _f !== void 0 ? _f : "";
          element.style.left = (_h = (_g = this.originalStyle) === null || _g === void 0 ? void 0 : _g.left) !== null && _h !== void 0 ? _h : "";
          element.style.width = (_k = (_j = this.originalStyle) === null || _j === void 0 ? void 0 : _j.width) !== null && _k !== void 0 ? _k : "";
          element.style.height = (_m = (_l = this.originalStyle) === null || _l === void 0 ? void 0 : _l.height) !== null && _m !== void 0 ? _m : "";
        }
      }

      var cover = options.backgroundMask.cover;
      var color = cover.color;
      var trail = options.particles.move.trail;
      var coverRgb = Utils_1.ColorUtils.colorToRgb(color);
      this.coverColor = coverRgb !== undefined ? {
        r: coverRgb.r,
        g: coverRgb.g,
        b: coverRgb.b,
        a: cover.opacity
      } : undefined;
      this.trailFillColor = Utils_1.ColorUtils.colorToRgb(trail.fillColor);
      this.initBackground();
      this.paint();
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas, generatedCanvas) {
      var _a;

      if (!canvas.className) {
        canvas.className = Utils_1.Constants.canvasClass;
      }

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      this.generatedCanvas = generatedCanvas !== null && generatedCanvas !== void 0 ? generatedCanvas : this.generatedCanvas;
      this.element = canvas;
      this.originalStyle = Utils_1.Utils.deepExtend({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this.context = this.element.getContext("2d");
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      if (this.context) {
        Utils_1.CanvasUtils.clear(this.context, this.size);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return;
      }

      this.element.width = this.size.width;
      this.element.height = this.size.height;
    }
  }, {
    key: "paint",
    value: function paint() {
      var options = this.container.options;

      if (!this.context) {
        return;
      }

      if (options.backgroundMask.enable && options.backgroundMask.cover && this.coverColor) {
        Utils_1.CanvasUtils.clear(this.context, this.size);
        this.paintBase(Utils_1.ColorUtils.getStyleFromRgb(this.coverColor, this.coverColor.a));
      } else {
        this.paintBase();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var options = this.container.options;
      var trail = options.particles.move.trail;

      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && this.trailFillColor) {
        this.paintBase(Utils_1.ColorUtils.getStyleFromRgb(this.trailFillColor, 1 / trail.length));
      } else if (this.context) {
        Utils_1.CanvasUtils.clear(this.context, this.size);
      }
    }
  }, {
    key: "windowResize",
    value: function windowResize() {
      if (!this.element) {
        return;
      }

      var container = this.container;
      var options = container.options;
      var pxRatio = container.retina.pixelRatio;
      container.canvas.size.width = this.element.offsetWidth * pxRatio;
      container.canvas.size.height = this.element.offsetHeight * pxRatio;
      this.element.width = container.canvas.size.width;
      this.element.height = container.canvas.size.height;

      if (!options.particles.move.enable) {
        container.particles.redraw();
      }

      container.densityAutoParticles();

      var _iterator = _createForOfIteratorHelper(container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (plugin.resize !== undefined) {
            plugin.resize();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "drawConnectLine",
    value: function drawConnectLine(p1, p2) {
      var _a;

      var lineStyle = this.lineStyle(p1, p2);

      if (!lineStyle) {
        return;
      }

      var ctx = this.context;

      if (!ctx) {
        return;
      }

      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      Utils_1.CanvasUtils.drawConnectLine(ctx, (_a = p1.linksWidth) !== null && _a !== void 0 ? _a : this.container.retina.linksWidth, lineStyle, pos1, pos2);
    }
  }, {
    key: "drawGrabLine",
    value: function drawGrabLine(particle, lineColor, opacity, mousePos) {
      var _a;

      var container = this.container;
      var ctx = container.canvas.context;

      if (!ctx) {
        return;
      }

      var beginPos = particle.getPosition();
      Utils_1.CanvasUtils.drawGrabLine(ctx, (_a = particle.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, beginPos, mousePos, lineColor, opacity);
    }
  }, {
    key: "drawParticleShadow",
    value: function drawParticleShadow(particle, mousePos) {
      if (!this.context) {
        return;
      }

      Utils_1.CanvasUtils.drawParticleShadow(this.container, this.context, particle, mousePos);
    }
  }, {
    key: "drawLinkTriangle",
    value: function drawLinkTriangle(p1, link1, link2) {
      var _a;

      var container = this.container;
      var options = container.options;
      var p2 = link1.destination;
      var p3 = link2.destination;
      var triangleOptions = p1.particlesOptions.links.triangles;
      var opacityTriangle = (_a = triangleOptions.opacity) !== null && _a !== void 0 ? _a : (link1.opacity + link2.opacity) / 2;

      if (opacityTriangle <= 0) {
        return;
      }

      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      var pos3 = p3.getPosition();
      var ctx = this.context;

      if (!ctx) {
        return;
      }

      if (Utils_1.NumberUtils.getDistance(pos1, pos2) > container.retina.linksDistance || Utils_1.NumberUtils.getDistance(pos3, pos2) > container.retina.linksDistance || Utils_1.NumberUtils.getDistance(pos3, pos1) > container.retina.linksDistance) {
        return;
      }

      var colorTriangle = Utils_1.ColorUtils.colorToRgb(triangleOptions.color);

      if (!colorTriangle) {
        var linksOptions = p1.particlesOptions.links;
        var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
        colorTriangle = Utils_1.ColorUtils.getLinkColor(p1, p2, linkColor);
      }

      if (!colorTriangle) {
        return;
      }

      Utils_1.CanvasUtils.drawLinkTriangle(ctx, pos1, pos2, pos3, options.backgroundMask.enable, options.backgroundMask.composite, colorTriangle, opacityTriangle);
    }
  }, {
    key: "drawLinkLine",
    value: function drawLinkLine(p1, link) {
      var _a, _b;

      var container = this.container;
      var options = container.options;
      var p2 = link.destination;
      var opacity = link.opacity;
      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      var ctx = this.context;

      if (!ctx) {
        return;
      }

      var colorLine;
      var twinkle = p1.particlesOptions.twinkle.lines;

      if (twinkle.enable) {
        var twinkleFreq = twinkle.frequency;
        var twinkleRgb = Utils_1.ColorUtils.colorToRgb(twinkle.color);
        var twinkling = Math.random() < twinkleFreq;

        if (twinkling && twinkleRgb !== undefined) {
          colorLine = twinkleRgb;
          opacity = twinkle.opacity;
        }
      }

      if (!colorLine) {
        var linksOptions = p1.particlesOptions.links;
        var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
        colorLine = Utils_1.ColorUtils.getLinkColor(p1, p2, linkColor);
      }

      if (!colorLine) {
        return;
      }

      var width = (_a = p1.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth;
      var maxDistance = (_b = p1.linksDistance) !== null && _b !== void 0 ? _b : container.retina.linksDistance;
      Utils_1.CanvasUtils.drawLinkLine(ctx, width, pos1, pos2, maxDistance, container.canvas.size, p1.particlesOptions.links.warp, options.backgroundMask.enable, options.backgroundMask.composite, colorLine, opacity, p1.particlesOptions.links.shadow);
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _this = this;

      var _a, _b, _c, _d;

      if (((_a = particle.image) === null || _a === void 0 ? void 0 : _a.loaded) === false || particle.spawning || particle.destroyed) {
        return;
      }

      var pfColor = particle.getFillColor();
      var psColor = (_b = particle.getStrokeColor()) !== null && _b !== void 0 ? _b : pfColor;

      if (!pfColor && !psColor) {
        return;
      }

      var container = this.container;
      var options = container.options;
      var particles = container.particles;
      var pOptions = particle.particlesOptions;
      var twinkle = pOptions.twinkle.particles;
      var twinkleFreq = twinkle.frequency;
      var twinkleRgb = Utils_1.ColorUtils.colorToRgb(twinkle.color);
      var twinkling = twinkle.enable && Math.random() < twinkleFreq;
      var radius = particle.getRadius();
      var opacity = twinkling ? twinkle.opacity : (_c = particle.bubble.opacity) !== null && _c !== void 0 ? _c : particle.opacity.value;
      var infectionStage = particle.infecter.infectionStage;
      var infection = options.infection;
      var infectionStages = infection.stages;
      var infectionColor = infectionStage !== undefined ? infectionStages[infectionStage].color : undefined;
      var infectionRgb = Utils_1.ColorUtils.colorToRgb(infectionColor);
      var fColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : infectionRgb !== null && infectionRgb !== void 0 ? infectionRgb : pfColor ? Utils_1.ColorUtils.hslToRgb(pfColor) : undefined;
      var sColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : infectionRgb !== null && infectionRgb !== void 0 ? infectionRgb : psColor ? Utils_1.ColorUtils.hslToRgb(psColor) : undefined;
      var fillColorValue = fColor !== undefined ? Utils_1.ColorUtils.getStyleFromRgb(fColor, opacity) : undefined;

      if (!this.context || !fillColorValue && !sColor) {
        return;
      }

      var strokeColorValue = sColor !== undefined ? Utils_1.ColorUtils.getStyleFromRgb(sColor, (_d = particle.stroke.opacity) !== null && _d !== void 0 ? _d : opacity) : fillColorValue;

      if (particle.links.length > 0) {
        this.context.save();
        var p1Links = particle.links.filter(function (l) {
          var linkFreq = container.particles.getLinkFrequency(particle, l.destination);
          return linkFreq <= pOptions.links.frequency;
        });

        var _iterator2 = _createForOfIteratorHelper(p1Links),
            _step2;

        try {
          var _loop = function _loop() {
            var link = _step2.value;
            var p2 = link.destination;

            if (pOptions.links.triangles.enable) {
              var links = p1Links.map(function (l) {
                return l.destination;
              });
              var vertices = p2.links.filter(function (t) {
                var linkFreq = container.particles.getLinkFrequency(p2, t.destination);
                return linkFreq <= p2.particlesOptions.links.frequency && links.indexOf(t.destination) >= 0;
              });

              if (vertices.length) {
                var _iterator3 = _createForOfIteratorHelper(vertices),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var vertex = _step3.value;
                    var p3 = vertex.destination;
                    var triangleFreq = particles.getTriangleFrequency(particle, p2, p3);

                    if (triangleFreq > pOptions.links.triangles.frequency) {
                      continue;
                    }

                    _this.drawLinkTriangle(particle, link, vertex);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            }

            if (link.opacity > 0 && container.retina.linksWidth > 0) {
              _this.drawLinkLine(particle, link);
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.context.restore();
      }

      if (radius > 0) {
        Utils_1.CanvasUtils.drawParticle(this.container, this.context, particle, delta, fillColorValue, strokeColorValue, options.backgroundMask.enable, options.backgroundMask.composite, radius, opacity, particle.particlesOptions.shadow);
      }
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      if (!this.context) {
        return;
      }

      Utils_1.CanvasUtils.drawPlugin(this.context, plugin, delta);
    }
  }, {
    key: "drawLight",
    value: function drawLight(mousePos) {
      if (!this.context) {
        return;
      }

      Utils_1.CanvasUtils.drawLight(this.container, this.context, mousePos);
    }
  }, {
    key: "paintBase",
    value: function paintBase(baseColor) {
      if (!this.context) {
        return;
      }

      Utils_1.CanvasUtils.paintBase(this.context, this.size, baseColor);
    }
  }, {
    key: "lineStyle",
    value: function lineStyle(p1, p2) {
      var options = this.container.options;
      var connectOptions = options.interactivity.modes.connect;

      if (this.context) {
        return Utils_1.CanvasUtils.gradient(this.context, p1, p2, connectOptions.links.opacity);
      }
    }
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.options;
      var background = options.background;
      var element = this.element;

      if (!element) {
        return;
      }

      var elementStyle = element.style;

      if (background.color) {
        var color = Utils_1.ColorUtils.colorToRgb(background.color);

        if (color) {
          elementStyle.backgroundColor = Utils_1.ColorUtils.getStyleFromRgb(color, background.opacity);
        }
      }

      if (background.image) {
        elementStyle.backgroundImage = background.image;
      }

      if (background.position) {
        elementStyle.backgroundPosition = background.position;
      }

      if (background.repeat) {
        elementStyle.backgroundRepeat = background.repeat;
      }

      if (background.size) {
        elementStyle.backgroundSize = background.size;
      }
    }
  }]);

  return Canvas;
}();

exports.Canvas = Canvas;